import type { C3Candidate, WhoDrugRecodePreview } from "@/lib/api/generated/casedb";

export const DEVICE_PRODUCT_TYPE_ID = 2;
export const WHODRUG_STATUS_LABELS: Record<string, string> = {
  MATCHED: "Dictionary entry selected", NO_MATCH: "No dictionary match", AMBIGUOUS: "Multiple matches · review required",
  UNAVAILABLE: "Dictionary unavailable", FAILED: "Dictionary search failed",
};
const unspecified = "Not specified";
export function dictionaryRow(candidate: C3Candidate) {
  const record = candidate.record;
  return {
    rid: record?.rid ?? "", name: record?.drugName ?? "", code: record?.drugCode ?? "",
    ingredients: candidate.ingredients?.map(item => item.substanceName).join("; ") || unspecified,
    country: record?.countryCode === "N/A" ? unspecified : record?.countryName || unspecified,
    mah: record?.mahId === "0" ? unspecified : record?.mahName || unspecified,
    form: record?.formId === "001" ? unspecified : record?.formText || unspecified,
    strength: record?.strengthId === "000001" ? unspecified : record?.strengthText || unspecified,
    archived: record?.archived === true,
  };
}
export function previewRows(preview?: WhoDrugRecodePreview) {
  return (preview?.changes ?? []).map(row => ({ ...row,
    current: row.currentValue || "Empty", proposed: row.proposedValue || "Empty",
    dictionary: row.dictionaryValue || unspecified,
  }));
}
export function entryDetails(preview?: WhoDrugRecodePreview) {
  const record = preview?.entry?.candidate?.record;
  return {
    name: record?.drugName || "Select an entry", rid: record?.rid || "", code: record?.drugCode || "",
    type: record?.productTypeText || unspecified,
    kind: record?.substanceOrSynonym === "Y" ? "Substance / substance synonym" : "Medicinal product",
    archived: record?.archived === true,
    identifiers: [
      ["Drug record number", record?.drugRecordNumber], ["Sequence 1", record?.sequence1],
      ["Sequence 2", record?.sequence2], ["Name specifier", record?.nameSpecifier],
      ["Country code", record?.countryCode], ["MAH identifier", record?.mahId],
      ["Form identifier", record?.formId], ["Strength identifier", record?.strengthId],
      ["Product type identifier", record?.productTypeId],
      ["Official release", preview?.entry?.release?.officialVersion],
    ].map(([label, value]) => ({ label, value: value || unspecified })),
    version: preview?.entry?.release?.shortVersion || "",
    atcs: (preview?.entry?.atcs ?? []).map(atc => ({ code: atc.code, text: atc.text, assignment: atc.assignmentType })),
    ingredients: (preview?.entry?.candidate?.ingredients ?? []).map(item => ({
      id: item.id, name: item.substanceName, substanceId: item.substanceId, cas: item.casNumber,
      quantity: item.quantity == null ? unspecified : `${item.quantity} ${item.unitText ?? ""}`,
      quantity2: item.quantity2 == null ? "" : `${item.quantity2} ${item.quantity2UnitText ?? ""}`,
    })),
  };
}
